import React from 'react'
import Link from '../link/Link'
import { FormattedMessage, useIntl } from 'react-intl'
import { makeStyles } from '@material-ui/core/styles'
import styles from '../../styles'
import { ClassValue } from 'classnames/types'
import classNames from 'classnames'
import { NewsExploitationModel } from '../../types/news/newsModel'
import { useMediaQuery } from 'react-responsive'
import { formatDateLong } from '../../utils/formatDate'
import { useHistory, useLocation } from 'react-router'
import links from '../../enums/linksEnum'
import { newsEnum } from '../../enums/newsEnum'
import { saveInteractions } from '../../modules/gtm/utils/gtmCallback'
import linksEnum from '../../enums/linksEnum'
import parse from 'html-react-parser'

const useStyle = makeStyles(
	(theme) => (
		{
			...styles(theme),
			exploitationContainerStyle: {
				marginBottom: 10,
				position: 'relative',

				'& .icon': {
					position: 'absolute',
					top: 27,
					left: 0,
					zIndex: 1,
					padding: 12,
					background: theme.palette.dynamic['90']
				}
			},
			exploitationStyle: {
				background: 'white',
				padding: '27px 34px 28px 56px',
				marginLeft: 43
			},
			residenceNameStyle: {
				marginTop: 0,

				'& p': {
					margin: 0
				}
			},
			textStyle: {
				wordBreak: 'break-word'
			}
		}
	)
)

interface AcceptingProps {
	newsExploitation: NewsExploitationModel[]
}

type ExploitationProps = AcceptingProps

const Exploitation: React.FC<ExploitationProps> = (
	{
		newsExploitation
	}
) => {
	const classes = useStyle()
	const history = useHistory()
	const location = useLocation()
	const intl = useIntl()
	const isLargeScreen = useMediaQuery(
		{
			query: '(min-width: 1025px)'
		}
	)

	const residenceNameClass: ClassValue = classNames(
		classes.residenceNameStyle,
		classes.text6_opacity,
		classes.colorBlue,
		classes.flex,
		classes.flexBetween
	)

	const titleClass: ClassValue = classNames(
		classes.colorAccessibility,
		isLargeScreen ? classes.title7 : classes.title3
	)

	const linkClass: ClassValue = classNames(
		classes.flex,
		classes.flexEnd
	)

	const seeDetails = (id: string, title: string) => {
		saveInteractions(
			{
				category: location.pathname === linksEnum.dashboard ? 'Tableau de bord' : '',
				action: location.pathname === linksEnum.dashboard ? 'Blocs de mise en avant' : '',
				label: `Actualites::${title}`
			}
		)

		history.push(`${links.newsDetails}/${newsEnum.actualite_exploitation}/${id}`)
	}

	/*const stripHtmlTags = (text: string) => {
		return text.replace(/<\/?[^>]+(>|$)/g, ' ').replace(/&nbsp;/g, '')
	}*/

	return (
		<>
			{
				newsExploitation.map(
					(exploitation) => (
						<div
							className={classes.exploitationContainerStyle}
							key={exploitation.id}
						>
							<div className="icon">
								<img
									src={exploitation.type}
									alt="Exploitation type"
									width={50}
									height={50}
								/>
							</div>

							<div className={classes.exploitationStyle}>
								<div className={residenceNameClass}>
									<p>{exploitation.residenceName && exploitation.residenceName}</p>
									<p>
										{formatDateLong(new Date(exploitation.beginning), intl.locale)}
									</p>
								</div>

								<h1 className={titleClass}>{exploitation.title}</h1>

								{
									exploitation.hook &&
									<div className={isLargeScreen ? classes.text2 : classes.text3_opacity}>
										{parse(exploitation.hook)}
									</div>
								}


								{
									exploitation.content &&
									<div className={linkClass}>
										<Link
											onClick={() => seeDetails(exploitation.id, exploitation.title)}
											color="colorAccessibility"
											textStyle="text8"

											ariaLabel={
												intl.formatMessage(
													{
														id: 'news.ariaLabel',
														defaultMessage: 'En savoir plus sur l\'actualité : {news}',
														description: 'Aria label text'
													},
													{ news: exploitation.title }
												)
											}
										>
											<FormattedMessage
												id="app.details"
												defaultMessage="En savoir plus"
												description="Learn more link"
											/>
										</Link>
									</div>
								}
							</div>
						</div>
					)
				)
			}
		</>
	)
}

export default Exploitation